import { NumberField } from './NumberField';
import React from 'react';

interface WholeNumberFieldProps {
  className?: string;
  value: number;
  max?: number;
  label?: string;
  disabled?: boolean;
  onChange: (value: number) => void;
}

export function WholeNumberField(props: WholeNumberFieldProps) {
  const { className, value, label, max, disabled, onChange } = props;
  return (
    <NumberField
      className={className}
      value={value}
      min={0}
      max={max}
      label={label}
      disabled={disabled}
      wholeNumbersOnly
      onValueChange={onChange}
    />
  );
}
